// import { Button, Tooltip } from "@mui/material";
// import { useNavigate } from "react-router-dom";

export const CancelTitleBarMenu = ({ caseId, clipId }) => {
  // const navigate = useNavigate();

  return <></>; // Remove this line after implementing glimpse cancel
  // return (
  //   <Tooltip title="Cancel Glimpse">
  //     <Button
  //       sx={{ color: "white", height: 1 }}
  //       onClick={() => navigate(`/app/cases/${caseId}/clips/${clipId}/editor`)}
  //     >
  //       CANCEL
  //     </Button>
  //   </Tooltip>
  // );
};
